import {
  ISetSettingsAction,
  ISetWicSettingsErrorAction,
  IWICSettingAction,
  IWicSettingsState,
} from './types';
import { RESET, SET_ERROR, SET_SETTINGS, SYNCING } from './actionTypes';

export const initialState: IWicSettingsState = {
  error: null,
  syncing: false,
  settings: {
    includeMerchantDiscountInItemPrice: false,
  },
  loaded: false,
};

export const reducer = (
  state: IWicSettingsState = initialState,
  action: IWICSettingAction
): IWicSettingsState => {
  switch (action.type) {
    case SYNCING:
      return { ...state, syncing: true };
    case SET_ERROR:
      return { ...state, syncing: false, error: (action as ISetWicSettingsErrorAction).payload };
    case SET_SETTINGS:
      return {
        ...state,
        error: null,
        syncing: false,
        settings: (action as ISetSettingsAction).payload,
        loaded: true,
      };
    case RESET:
      return initialState;

    default:
      return state;
  }
};
